import styled from 'styled-components';
import {
    space,
    layout,
    typography,
    color,
    border,
    position,
    SpaceProps,
    LayoutProps,
    TypographyProps,
    ColorProps,
    BorderProps,
    PositionProps,
} from 'styled-system';
import { StyledTH } from '../th/styles';

type Props = SpaceProps & LayoutProps & TypographyProps & ColorProps & BorderProps & PositionProps;

export const StyledTHead = styled.thead<Props>`
    font-weight: ${({ theme }) => theme.fontWeights.medium};

    ${space}
    ${layout}
  ${typography}
  ${color}
  ${border}
  ${position}

  ${StyledTH} {
        padding: ${({ theme }) => theme.space[5]} ${({ theme }) => theme.space[4]};
        color: ${({ theme }) => theme.colors.table.header.text};
        background-color: ${({ theme }) => theme.colors.table.header.background};
        font-weight: ${({ theme }) => theme.fontWeights.medium};
    }
`;
